import { salesDataSourceSaveInternalNotes } from 'commons/service/bank/salesData'
import { SalesDataSourceSaveInternalNotesPayload } from 'commons/types/DTO/bank/salesDataSourceWebPage'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSalesDataSourceSaveInternalNotes: WriteHook<SalesDataSourceSaveInternalNotesPayload, void> = (opts) =>
  useMutationManager<SalesDataSourceSaveInternalNotesPayload, void>(salesDataSourceSaveInternalNotes, opts)
